export enum AllocationType {
    CALCULATED="calculated",
    NAMEPLATE="nameplate",
    PEAK="peak",
}